<template>
  <section class="admin-panel">
    <mdb-container>
      <mdb-row class="title">
        <mdb-col md="12">
          <h1 class="text-left">
            Videos
          </h1>
          <router-link to="/admin/videos/add">
            <mdb-btn color="primary" class="sm m-0 outline" rounded><mdb-icon icon="plus-square" /> Add video</mdb-btn>
          </router-link>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="12">
          <mdb-tbl>
            <thead class="">
              <tr>
                <th></th>
                <th>Title</th>
                <th>Vimeo ID</th>
                <th class="text-center">Edit</th>
                <th class="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,index) in videos" v-bind:key="'tr'+v.id+index">
                <th scope="row">{{v.lp}}</th>
                <td @click="goToEdit(v.id)"><strong>{{v.name}}</strong></td>
                <td>{{v.vimeoid}}</td>
                <td class="narrow text-center" @click="goToEdit(v.id)">
                  <mdb-icon icon="edit round-click sm bg-purple"></mdb-icon>
                  
                </td>
                <td class="narrow text-center" @click="deleteVideo(v.id)">
                  <mdb-icon icon="trash round-click bg-red"></mdb-icon>
                </td>
              </tr>
              <!-- <tr>
                <th scope="row">2</th>
                <td>Introduction to the platform</td>
                <td>327081467</td>
                <td>
                  <mdb-icon icon="edit" />
                </td>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td>Active listening</td>
                <td>327024475</td>
                <td>
                  <mdb-icon icon="edit" />
                </td>
              </tr>-->
            </tbody>
          </mdb-tbl>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";

export default {
  name: "AdminVideos",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn
  },
  created() {
    this.refvideos.onSnapshot(querySnapshot => {
      console.log("onsnapshot fired");
      this.videos = [];
      var lp = 0;
      querySnapshot.forEach(doc => {
        lp++;
        this.videos.push({
          id: doc.id,
          lp: lp,
          name: doc.data().name,
          category: doc.data().category,
          plan: doc.data().plan,
          subcategory: doc.data().subcategory,
          vimeoid: doc.data().vimeoid,
          tags: doc.data().tags
        });
      });
    });
  },
  data() {
    return {
      videos: [],
      refvideos: firebase.firestore().collection("videos")
    };
  },
  methods: {
    deleteVideo(id){
      if(confirm('Are you sure?'))
      {
         firebase
          .firestore()
          .collection("videos")
          .doc(id)
          .delete();
      }
    },
    goToEdit(videoid) {
      console.log('go to edit clicked');
      console.log('videoid='+videoid);

      this.$router.replace("/admin/videos/edit/" + videoid);
    },
    makeRouterLink(videoid) {
      return "admin/videos/edit/" + videoid;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}
</style>
